import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#0a5c36', // أخضر غامق
      light: '#1a8e50', // أخضر متوسط
      dark: '#0a3622', // أخضر داكن جداً
    },
    secondary: {
      main: '#4cd174', // أخضر فاتح
      light: '#7dff9b',
      dark: '#2ba04f',
    },
    background: {
      default: '#0a3622', // خلفية خضراء داكنة
      paper: '#0a5c36', // خلفية عناصر الواجهة
    },
    text: {
      primary: '#ffffff', // نص أبيض
      secondary: '#e0e0e0', // نص رمادي فاتح
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Tahoma", "Arial", sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    button: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default theme;
